import {FilterVO} from "./models/filter-vo";
import {FilterKeys} from "./enums/filter-keys";

export class BaseFilterHelper {
  filter: FilterVO<any>[] = [];
  activeFilters: Set<string> = new Set<string>();
  constructor() {
  }

  addFilter<T>(filter: FilterVO<T>) {
    this.filter.push(filter);
    this.activeFilters.add(`${filter.key}-${filter.value}`);
  }

  removeFilter<T>(filter: FilterVO<T>): boolean {
    let filter_ = this.filter.find(f => f.key === filter.key && f.value === filter.value);
    if (filter_) {
      this.filter.splice(this.filter.indexOf(filter_), 1);
      this.activeFilters.delete(`${filter.key}-${filter.value}`);
      return true;
    }
    return false;
  }

  filterExists<T>(filter: FilterVO<T>): boolean {
    return this.activeFilters.has(`${filter.key}-${filter.value}`);
  }

  isFilterActive(key: FilterKeys, value: string | number | undefined): boolean {
    return this.activeFilters.has(`${key}-${value}`);
  }
}
